import { useEffect } from 'react';
import { useAuth } from '@lingugeek/state-management';
import LoadingSpinner from '@/components/LoadingSpinner';
import { useNavigate } from 'react-router-dom';

interface AuthGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function AuthGuard({ children, fallback }: AuthGuardProps) {
  const navigate = useNavigate();
  const { user, isLoading: userLoading } = useAuth();

  useEffect(() => {
    if (!userLoading && !user) {
      navigate('/login');
    }
  }, [user, userLoading, navigate]);

  if (userLoading) {
    return (
      fallback || (
        <div className='flex items-center justify-center min-h-screen bg-gray-50'>
          <LoadingSpinner size='lg' />
        </div>
      )
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}
